import { createSelector } from 'reselect';
import { getDashboardReducer } from '../selectorIndex';

export const getIsMobileMenuOpen = createSelector(
    [getDashboardReducer],
    dashboardReducer => dashboardReducer.isMobileMenuOpen
);
